__turbopack_context__.v({
  "activeOfferListItem": "styles-module__6HczXW__activeOfferListItem",
  "activeOffersContainer": "styles-module__6HczXW__activeOffersContainer",
  "seeMoreText": "styles-module__6HczXW__seeMoreText",
});
